export const helper = {
  variable_default: []
};
